import genRandomString from 'hero-utils/genRandomString';
import genEncodedHash from './genEncodedHash';
const genClientAuthCodes = async () => {
    const state = genRandomString();
    const code_verifier = genRandomString();
    const code_challenge = await genEncodedHash(code_verifier);
    return {
        code_challenge,
        code_verifier,
        state
    };
};
export default genClientAuthCodes;
//# sourceMappingURL=index.js.map